import React, { useState } from 'react';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import LandingNav from '../common/LandingNav/LandingNav';
import './Auth.css';

export default function Auth({ from }) {
  const [currentView, setCurrentView] = useState('signin');

  const switchToSignIn = () => setCurrentView('signin');
  const switchToSignUp = () => setCurrentView('signup');
  const switchToForgotPassword = () => setCurrentView('forgot-password');

  const renderCurrentView = () => {
    switch (currentView) {
      case 'signin':
        return (
          <SignIn
            onSwitchToSignUp={switchToSignUp}
            onSwitchToForgotPassword={switchToForgotPassword}
            from={from}
          />
        );
      case 'signup':
        return (
          <SignUp
            onSwitchToSignIn={switchToSignIn}
          />
        );
      case 'forgot-password':
        return (
          <ForgotPassword
            onSwitchToSignIn={switchToSignIn}
          />
        );
      default:
        return (
          <SignIn
            onSwitchToSignUp={switchToSignUp}
            onSwitchToForgotPassword={switchToForgotPassword}
          />
        );
    }
  };

  return (
    <div className="auth-page">
      <LandingNav showAuthButton={true} />
      
      <div className="auth-background">
        <div className="auth-background-overlay"></div>
      </div>
      
      <div className="auth-content">
        <div className="auth-card">
          {renderCurrentView()}
        </div>
        
        <div className="auth-footer">
          <p>&copy; 2026 OmniContext. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
